/** 广场 */
export const plaza = [
  {
    name: 'getPost', // ai帖子-详情
    isMock: false,
  },
  {
    name: 'aiArtworkPostSame', // 一键同款-生成ai创作
    isMock: false,
  },
  {
    name: 'createPost', // 创建帖子
    isMock: false,
  },
  {
    name: 'updatePost', // 编辑帖子
    isMock: false,
  },
  {
    name: 'downloadImage', // 下载原图
    isMock: false,
  },
]
